var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  viewBox: "0 0 46 46"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 22
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M22 14v16M30 22H14"
}))));
export default SvgPlusCircle;